// extracted by mini-css-extract-plugin
export default {"search_result":"addOrderCashAdmin_search_result__gPG+g"};